
import { ProfileAdministrationAPI } from "../api";
import { Product } from "../types/PersologOnlineTypes.ts";

/**
 * Fetch all purchaseable products for that trainer (includes distributor specific products)
 * @param trainerId
 * @returns Promise<Product[]> - all products for that trainer
 */
export async function fetchAllProductsForTrainer(trainerId: string): Promise<Product[]> {
    return await ProfileAdministrationAPI.fetchAllProductsForTrainer(trainerId);
}

export type EditableProduct = {
  id: number; // Possibly redundant
  product: string;
  trainer: string;
  quantity: number;
  isPurchased: boolean;
};